import { render } from "./NewAlert.vue?vue&type=template&id=5f41c4df&scoped=true"
import script from "./NewAlert.vue?vue&type=script&lang=js"
export * from "./NewAlert.vue?vue&type=script&lang=js"

import "./NewAlert.vue?vue&type=style&index=0&id=5f41c4df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f41c4df"]])

export default __exports__